// src/services/CheckInService.js
import axios from 'axios';
import config from '../config/config';

export class CheckInService {
  static async checkIn(formData) {
    try {
      
      const response = await axios.post(`${config.BASE_URL}/api/checkin`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
      
      return response.data;
    } catch (error) {
      console.error('CheckIn error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to check in'
      };
    }
  }
  
  static async getCheckInStatus(userId, eventId) {
    try {
      
      const response = await axios.get(`${config.BASE_URL}/api/checkin/checkin-status/${userId}/${eventId}`);
      // Handle various response formats
      return {
        checked_in: response.data?.checked_in || (response.data?.success && response.data?.checkin),
        timestamp: response.data?.timestamp || response.data?.checkin?.created_at || null
      };
    } catch (error) {
      console.error('Error getting check-in status:', error);
      return { checked_in: false, timestamp: null };
    }
  }
}

export default CheckInService;
